import unbindNode from '../unbindnode/index.js';
import getProp from '../_helpers/getprop.js';
// returns a function which re-adds binding when object branch is changed
// the function is called by bindNode when something like
// 'foo.bar.baz' is passed to it as key argument value
// this is one of the hardest things in the framework to understand
// deepBinding.$nodes is read on every call: unbindNode removes nodes from it
export default function createBindingSwitcher(_ref) {
  var object = _ref.object,
    deepBinding = _ref.deepBinding,
    binder = _ref.binder,
    eventOptions = _ref.eventOptions,
    bindKey = _ref.bindKey;
  return function bindingSwitcher(changeEvent) {
    if (changeEvent === void 0) {
      changeEvent = {};
    }
    var deepPath = deepBinding.deepPath,
      $nodes = deepBinding.$nodes;
    var deepPathLength = deepPath.length;
    var lastDeepPathItem = deepPath[deepPathLength - 1];
    var _changeEvent = changeEvent,
      value = _changeEvent.value,
      previousValue = _changeEvent.previousValue,
      restPath = _changeEvent.restPath;
    // a forced set of a branch to the same object leaves the binding where it is
    if (restPath && value === previousValue) {
      return;
    }
    var target; // an object to call bindKey
    var previousTarget; // an object to call unbindNode
    if (value && typeof value === 'object' && restPath) {
      // if rest path is given and new value is an object
      target = value;
      for (var i = 0; i < restPath.length; i++) {
        target = getProp(target, restPath[i]);
        if (!target) {
          break;
        }
      }
    } else {
      // if rest path is not given
      target = object;
      for (var _i = 0; _i < deepPathLength - 1; _i++) {
        target = getProp(target, deepPath[_i]);
        if (!target) {
          break;
        }
      }
    }
    // if rest path is given and previous value is an object
    if (previousValue && typeof previousValue === 'object' && restPath) {
      previousTarget = previousValue;
      for (var _i2 = 0; _i2 < restPath.length; _i2++) {
        previousTarget = getProp(previousTarget, restPath[_i2]);
        if (!previousTarget) {
          break;
        }
      }
    }
    // remove binding for previously used object; first, so a target both share keeps its binding
    if (previousTarget && typeof previousTarget === 'object') {
      unbindNode(previousTarget, lastDeepPathItem, $nodes, eventOptions);
    }
    // add binding for new target
    if (target && typeof target === 'object') {
      bindKey(target, lastDeepPathItem, $nodes, binder, eventOptions);
    }
  };
}